const scrollToTop = () => {
	const backToTopButton = document.querySelectorAll(".footer__back-to-top");

	if (backToTopButton?.length) {
		const scrollToPageTop = () => {
			if (window.ScrollSmoother && ScrollSmoother.get()) {
				// Use ScrollSmoother if available (same pattern as hero banner)
				ScrollSmoother.get().scrollTo(0, true);
			} else {
				// Fallback to regular smooth scroll
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			}
		};

		backToTopButton.forEach((button) => {
			button.addEventListener("click", scrollToPageTop);
		});
	}
};

if (document.readyState !== "loading") {
	scrollToTop();
} else {
	document.addEventListener("DOMContentLoaded", scrollToTop);
}
